import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, Router, UrlTree} from '@angular/router';
import {SaleReportType} from '@emma-labs/shared/typescript';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ArchivedProposalService} from '../../services/proposal/archived-proposal.service';

export const ArchivedProposalPageGuard = (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const archivedProposalService = inject(ArchivedProposalService);

  const archivedProposalId = atob(route.params['archivedProposalId']);

  if (!archivedProposalId) {
    throw new Error('No archived proposal id found');
  }

  return archivedProposalService.get(archivedProposalId).pipe(
    map((archivedProposal) => {
      if (archivedProposal.saleReport.type === SaleReportType.EXTERNAL) {
        return router.parseUrl('/dashboard/sale-report-search');
      }

      return true;
    }),
  );
};
